module.exports = __webpack_public_path__ + "img/202407_02.d6b337f1.jpg";